(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["puppy-pool-pillow-home"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  if (!document.getElementById('pph-fonts')) {
    var link = document.createElement('link');
    link.id = 'pph-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@600;700;800&family=Inter:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puppy-pool-pillow"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  if (!document.getElementById('pp-fonts')) {
    var link = document.createElement('link');
    link.id = 'pp-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@600;700;800&family=Inter:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
  }

  document.querySelectorAll('.pp-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answer = btn.nextElementSibling;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.closest('.pp-faq-list').querySelectorAll('.pp-faq-q').forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        if (b.nextElementSibling) b.nextElementSibling.hidden = true;
      });
      if (!isOpen) { btn.setAttribute('aria-expanded', 'true'); answer.hidden = false; }
    });
  });

})();

  } catch(e) { console.error(e); }
})();
})();
